module.exports = __webpack_public_path__ + "img/lb3_h5.121b4654.png";